import { flowRight as compose } from 'lodash';

import queries from '~lib/common/queries/LabAsset';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withUser from '~lib/common/hoc/withUser';

import CaseLabMedia from './CaseLabMedia.vue';

const enhance = compose(
  dataView({ queries }),
  renameProps({ data: 'labAssets' }),
  withUser()
);

export default enhance(CaseLabMedia);
